// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3QlWP","legacyBtn":"MutateMid_legacyBtn__2N_dg"};